import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Сбрасывает скролл наверх при переходе между страницами.
 * React Router по умолчанию сохраняет позицию скролла — из-за этого
 * страница входа/регистрации открывалась прокрученной вниз, если
 * на главной перед этим скроллили. Этот компонент ничего не рендерит,
 * только слушает смену pathname.
 *
 * Якорные переходы (#games, #about и т.п.) не трогаем — у них есть hash,
 * браузер сам скроллит к якорю.
 */
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) return; // переход к якорю — не мешаем браузеру
    window.scrollTo(0, 0);
  }, [pathname, hash]);

  return null;
}
